import is from '../../../comparator/is';

import { IStorageEngine } from './storage-engine';

export class LocalStorage implements IStorageEngine {
  private _window: Window;

  constructor(
    private appId: string,
    frameWindow?: Window,
  ) {
    if (frameWindow) {
      this._window = frameWindow;
    } else {
      this._window = window;
    }
  }

  set(key: string, value: any, expire?: Date) {
    if (is.nullOrUndefined(key)) {
      return;
    }
    const appKey = `${this.appId}-${key}`;
    this._window.localStorage.setItem(appKey, value);
    /*** value为null或undefined时,执行删除操作 ***/
    if (is.nullOrUndefined(value)) {
      this.remove(key);
      return;
    }
    /*** 设置过期时间 ***/
    if (expire) {
      const keyExpire = `${appKey}-expire`;
      const expireStr = expire.toISOString();
      this._window.localStorage.setItem(keyExpire, expireStr);
    }
  }

  get(key: string): string | null {
    /*** 不存在指定key的缓存 ***/
    if (is.nullOrUndefined(key)) {
      return null;
    }
    const appKey = `${this.appId}-${key}`;
    const keyExpire = `${appKey}-expire`;

    if (this.hasKey(keyExpire) && this.isExpried(key)) {
      return null;
    }

    return this._window.localStorage.getItem(appKey);
  }

  remove(key: string) {
    /*** 不存在指定key的缓存 ***/
    if (is.nullOrUndefined(key)) {
      return;
    }
    const appKey = `${this.appId}-${key}`;
    const keyExpire = `${appKey}-expire`;
    /*** 删除指定key的缓存 ***/
    this._window.localStorage.removeItem(appKey);
    /*** 删除指定key的过期时间缓存 ***/
    this._window.localStorage.removeItem(keyExpire);
  }

  clearAll() {
    // 根据appId逐个删除
    for (const key in this._window.localStorage) {
      if (key.indexOf(`${this.appId}-`) > -1) {
        this._window.localStorage.removeItem(key);
      }
    }
  }

  hasKey(key: string): boolean {
    const appKey = `${this.appId}-${key}`;
    const content = this._window.localStorage.getItem(appKey);
    /*** 找不到指定key缓存则代表不存在 ***/
    return !is.nullOrUndefined(content);
  }

  isExpried<T>(key: string): boolean {
    const appKey = `${this.appId}-${key}`;
    const keyExpire = `${appKey}-expire`;

    /*** 不存在指定key的缓存 ***/
    // 若不存在,视为过期返回false
    if (!this.hasKey(key)) {
      return true;
    }

    // 过期时间
    const expire = this._window.localStorage.getItem(keyExpire);
    /*** 不存在过期时间 ***/
    if (is.nullOrUndefined(expire)) {
      return false;
    }

    /*** 判断是否过期 ***/
    // 保存时间
    const savedTimeDate = new Date(expire);
    const savedTime = savedTimeDate.getTime();
    // 当前时间
    const currentTime = Date.now();
    return savedTime < currentTime;
  }
}
